"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var patch_exports = {};
__export(patch_exports, {
  applyPatch: () => applyPatch,
  applyPatches: () => applyPatches
});
module.exports = __toCommonJS(patch_exports);
var import_communication_types = require("@hcengineering/communication-types");
function applyPatches(message, patches, allowedPatchTypes = []) {
  if (patches.length === 0) return message;
  for (const p of patches) {
    message = applyPatch(message, p, allowedPatchTypes);
  }
  return message;
}
__name(applyPatches, "applyPatches");
function applyPatch(message, patch, allowedPatchTypes = []) {
  if (allowedPatchTypes.length > 0 && !allowedPatchTypes.includes(patch.type) || message.removed) {
    return message;
  }
  switch (patch.type) {
    case import_communication_types.PatchType.update: {
      if (patch.created.getTime() < (message.edited?.getTime() ?? 0)) {
        return message;
      }
      return {
        ...message,
        edited: patch.created,
        content: patch.data.content ?? message.content,
        extra: patch.data.extra ?? message.extra
      };
    }
    case import_communication_types.PatchType.remove: {
      return {
        ...message,
        content: "",
        attachments: [],
        reactions: [],
        removed: true
      };
    }
    case import_communication_types.PatchType.reaction:
      return patchReactions(message, patch);
    case import_communication_types.PatchType.attachment:
      return patchAttachments(message, patch);
    case import_communication_types.PatchType.thread:
      return patchThread(message, patch);
  }
}
__name(applyPatch, "applyPatch");
function patchAttachments(message, patch) {
  if (patch.data.operation === "add") {
    return addAttachments(message, patch.data.attachments, patch.created, patch.creator);
  } else if (patch.data.operation === "remove") {
    return removeAttachments(message, patch.data.ids);
  } else if (patch.data.operation === "set") {
    return setAttachments(message, patch.data.attachments, patch.created, patch.creator);
  } else if (patch.data.operation === "update") {
    return updateAttachments(message, patch.data.attachments, patch.created);
  }
  return message;
}
__name(patchAttachments, "patchAttachments");
function patchReactions(message, patch) {
  if (patch.data.operation === "add") {
    return setReaction(message, patch.data.reaction, patch.creator, patch.created);
  } else if (patch.data.operation === "remove") {
    return removeReaction(message, patch.data.reaction, patch.creator);
  }
  return message;
}
__name(patchReactions, "patchReactions");
function setReaction(message, reaction, creator, created) {
  const isExist = message.reactions.some((it) => it.reaction === reaction && it.creator === creator);
  if (isExist) return message;
  message.reactions.push({
    reaction,
    creator,
    created
  });
  return message;
}
__name(setReaction, "setReaction");
function removeReaction(message, reaction, creator) {
  const reactions = message.reactions.filter((it) => it.reaction !== reaction || it.creator !== creator);
  if (reactions.length === message.reactions.length) return message;
  return {
    ...message,
    reactions
  };
}
__name(removeReaction, "removeReaction");
function addAttachments(message, data, created, creator) {
  const newAttachments = [];
  for (const attach of data) {
    const isExists = message.attachments.some((it) => it.id === attach.id);
    if (isExists === void 0) continue;
    const attachment = {
      ...attach,
      created,
      creator
    };
    newAttachments.push(attachment);
  }
  if (newAttachments.length === 0) return message;
  return {
    ...message,
    attachments: [...message.attachments, ...newAttachments]
  };
}
__name(addAttachments, "addAttachments");
function updateAttachments(message, updates, date) {
  if (updates.length === 0) return message;
  const updatedAttachments = [];
  for (const attachment of message.attachments) {
    const update = updates.find((it) => it.id === attachment.id);
    if (update === void 0) {
      updatedAttachments.push(attachment);
    } else {
      updatedAttachments.push({
        ...attachment,
        params: {
          ...attachment.params,
          ...update.params
        },
        modified: date.getTime() > (attachment.modified?.getTime() ?? 0) ? date : attachment.modified
      });
    }
  }
  return {
    ...message,
    attachments: updatedAttachments
  };
}
__name(updateAttachments, "updateAttachments");
function removeAttachments(message, ids) {
  const attachments = message.attachments.filter((it) => !ids.includes(it.id));
  if (attachments.length === message.attachments.length) return message;
  return {
    ...message,
    attachments
  };
}
__name(removeAttachments, "removeAttachments");
function setAttachments(message, data, created, creator) {
  if (data.length === 0) return message;
  return {
    ...message,
    attachments: data.map(
      (it) => ({
        ...it,
        created,
        creator
      })
    )
  };
}
__name(setAttachments, "setAttachments");
function patchThread(message, patch) {
  if (patch.data.operation === "attach") {
    return attachThread(message, patch.data.threadId, patch.data.threadType);
  } else if (patch.data.operation === "update") {
    return updateThread(
      message,
      patch.data.threadId,
      patch.data.threadType,
      patch.data.repliesCountOp,
      patch.data.lastReply
    );
  }
  return message;
}
__name(patchThread, "patchThread");
function attachThread(message, threadId, threadType) {
  if (message.thread !== void 0) return message;
  return {
    ...message,
    thread: {
      cardId: message.cardId,
      messageId: message.id,
      threadId,
      threadType,
      repliesCount: 0,
      lastReply: /* @__PURE__ */ new Date()
    }
  };
}
__name(attachThread, "attachThread");
function updateThread(message, threadId, threadType, repliesCountOp, lastReply) {
  if (repliesCountOp === void 0 && lastReply === void 0) return message;
  if (message.thread === void 0) return message;
  if (message.thread.threadId !== threadId) return message;
  let count = message.thread.repliesCount;
  if (repliesCountOp === "increment") {
    count = count + 1;
  }
  if (repliesCountOp === "decrement") {
    count = Math.max(count - 1, 0);
  }
  return {
    ...message,
    thread: {
      ...message.thread,
      repliesCount: count,
      threadType: threadType ?? message.thread.threadType,
      lastReply: lastReply ?? message.thread.lastReply
    }
  };
}
__name(updateThread, "updateThread");
//# sourceMappingURL=patch.js.map
